import Image from 'next/image';

interface LogoImageProps {
  theme: 'default' | 'white';
  width: number;
  height: number;
}

const LogoImage = ({ theme, width, height }: LogoImageProps) => {
  const imagePath = theme === 'default' ? '/icons/logo.png' : '/icons/logo-white.png';
  return <Image src={imagePath} alt="logo" width={width} height={height} priority />;
};

export default LogoImage;
